import { Button } from 'blaze-ui/Button'
import Styles from './Distribution.module.scss'
import { Form, Formik } from 'formik'
import { DistributionProps } from './Types'
import {
  BlogSection,
  EmailSection,
  SocialMediaSection,
} from 'screens/Campaign/Overview/EditChannelsModal/EditChannelsModal'
import { validationSchema as ChannelsValidationSchema } from 'screens/Campaign/Overview/EditChannelsModal/validationSchema'
import { ModalSubmitContainer } from 'screens/Campaigns/components/BatchCreateCampaignsModal/ModalLayoutProvider/ModalSubmitContainer'
import {
  mergeCrosspostDefaults,
  mergeEmailDefaults,
  mergeFacebookDefaults,
  mergeInstagramDefaults,
  mergeLinkedInDefaults,
  mergeSeoDefaults,
  mergeTiktokDefaults,
  mergeTwitterDefaults,
  mergeVideoCrosspostDefaults,
  mergeYoutubeDefaults,
} from 'utils/brandPlans/mergeDefaultContents'

export const Distribution = ({
  instagramContents,
  emailContents,
  facebookContents,
  linkedinContents,
  seoContents,
  tiktokContents,
  twitterContents,
  youtubeContents,
  onNext,
  weekDays,
  crosspostContents,
  crosspostFrequency,
  videoCrosspostContents,
  googleMyBusinessContents,
  tactics,
}: DistributionProps) => {
  return (
    <Formik
      validateOnMount
      validationSchema={ChannelsValidationSchema}
      initialValues={{
        instagram_contents: mergeInstagramDefaults(instagramContents),
        email_contents: mergeEmailDefaults(emailContents),
        facebook_contents: mergeFacebookDefaults(facebookContents),
        linkedin_contents: mergeLinkedInDefaults(linkedinContents),
        seo_contents: mergeSeoDefaults(seoContents),
        tiktok_contents: mergeTiktokDefaults(tiktokContents),
        twitter_contents: mergeTwitterDefaults(twitterContents),
        youtube_contents: mergeYoutubeDefaults(youtubeContents),
        week_days: weekDays,
        crosspost_frequency: crosspostFrequency,
        crosspost_contents: mergeCrosspostDefaults(crosspostContents),
        video_crosspost_contents: mergeVideoCrosspostDefaults(videoCrosspostContents),
        google_my_business_contents: googleMyBusinessContents || [],
        tactics,
      }}
      onSubmit={(values) => onNext(values)}
    >
      {({ submitForm, isSubmitting, isValid, ...rest }) => {
        return (
          <Form className={Styles.form}>
            <SocialMediaSection />
            <BlogSection />
            <EmailSection />
            <ModalSubmitContainer>
              <Button size="lg" onPress={() => submitForm()} isDisabled={isSubmitting || !isValid}>
                Create Campaign
              </Button>
            </ModalSubmitContainer>
          </Form>
        )
      }}
    </Formik>
  )
}
